import styled from "styled-components";

export const FooterWrapper = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 130px;
  padding: 16px;
  margin-top: auto;

  background: white;

  img {
    height: 100%;
  }

  div {
    margin-left: 32px;
  }

  p,
  address {
    margin: 0;
    font-size: 13px;
  }

  address {
    color: #848e90;
  }

  p {
    color: #3a4041;
    font-weight: 600;
  }
`;
